/** The native Studio document is written into a nested iframe and therefore
 * inherits the configured app-host origin, not the top-frame origin. Window
 * parent identity is cross-origin accessible; no host document is inspected. */
export function isExpectedHostSource(
  event: Pick<MessageEvent, "origin" | "source">,
  expectedOuter: Window | null,
  expectedOrigin: string,
): boolean {
  if (
    !expectedOuter ||
    !event.source ||
    !expectedOrigin ||
    expectedOrigin === "null" ||
    event.origin !== expectedOrigin
  )
    return false;
  try {
    const source = event.source as Window;
    return (
      typeof source.postMessage === "function" &&
      source.parent === expectedOuter
    );
  } catch {
    return false;
  }
}
